export const SLIDER_ITEM_TYPES = {
  HTML_SNIPPET: 'HTML snippet',
  IMAGE: 'Image'
} as const;
